export default __webpack_public_path__ + "static/chidog-logo-e7cf72bb52091ed230c1a4db4fd62986.png";